import getCurrentColorPalette from './get-current-color-palette';
import getCurrentFontPair from './get-current-font-pair';
import getCurrentButtonPreset from './get-current-button-preset';
import getEffectsConfig from './get-effects-config';
import getTheme from './get-theme';
import getCustomTextColors from './get-custom-text-colors';
import getColorPaletteConfig from './get-color-palette-config';

export default {
  getCurrentColorPalette,
  getCurrentFontPair,
  getCurrentButtonPreset,
  getEffectsConfig,
  getTheme,
  getCustomTextColors,
  getColorPaletteConfig,
};
